import script from "./compGroupDetailLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./compGroupDetailLocation.vue?vue&type=script&setup=true&lang=js"

import "./compGroupDetailLocation.vue?vue&type=style&index=0&id=5caf0a4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5caf0a4f"]])

export default __exports__